export default __webpack_public_path__ + "static/media/InsuranceCert.5da42db5.png";